import dayjs, { Dayjs } from "dayjs";
import { FilterValue } from "../Filters/FilterValue";
import { OrderType } from "../Project/OrderType";
import { SortType } from "../SortType";

const defaultOrderTypes = () => OrderType.filter((t) => t.id !== "7");

const mapOrderTypes = (items?: FilterValue[]): FilterValue[] => {
  if (!items?.length) return defaultOrderTypes();
  return items
    .map((item) => OrderType.find((o) => o.id === String(item.id)))
    .filter((t): t is FilterValue => !!t);
};

export interface OpsSyncFilters {
  page_no?: number;
  limit?: number;
  sort_type?: SortType;
  sort_by?: string;
  search_text?: string;
  order_id?: FilterValue[];
  id?: FilterValue[];
  order_category?: FilterValue[];
  order_type?: FilterValue[];
  payment_status_id?: FilterValue[];
  dispatch_date_filter_type?: FilterValue | null;
  archived?: boolean;
  created_date_from?: Dayjs | null;
  created_date_to?: Dayjs | null;
  dispatch_date_from?: Dayjs | null;
  dispatch_date_to?: Dayjs | null;
}

export interface OpsSyncSelectedFilters {
  page_no?: number;
  limit?: number;
  sort_type?: SortType;
  sort_by?: string;
  search_text?: string;
  order_id?: FilterValue[];
  id?: FilterValue[];
  order_category?: FilterValue[];
  order_type?: FilterValue[];
  payment_status_id?: FilterValue[];
  dispatch_date_filter_type?: FilterValue | null;
  archived?: boolean;
  created_date_from?: string | null;
  created_date_to?: string | null;
  dispatch_date_from?: string | null;
  dispatch_date_to?: string | null;
}

export function parseQueryParamsForOpsSyncFilters(
  params: OpsSyncFilters | null,
  query_params: URLSearchParams,
): OpsSyncFilters {
  const parseDate = (dateValue: any): Dayjs | null => {
    if (!dateValue) return null;
    if (typeof dateValue === "string") {
      const parsed = dayjs(dateValue);
      return parsed.isValid() ? parsed : null;
    }
    if (typeof dateValue === "object" && dateValue.format) {
      return dateValue;
    }
    return null;
  };

  return {
    order_id: params?.order_id ?? [],
    id: params?.id ?? [],
    order_category: params?.order_category ?? [],
    order_type: mapOrderTypes(params?.order_type),
    payment_status_id: params?.payment_status_id ?? [],
    dispatch_date_filter_type: params?.dispatch_date_filter_type ?? null,
    archived: params?.archived ?? false,
    limit: params?.limit ?? 30,
    created_date_from: query_params.get("created_date_from")
      ? dayjs(query_params.get("created_date_from"), "YYYY-MM-DD")
      : parseDate(params?.created_date_from),
    created_date_to: query_params.get("created_date_to")
      ? dayjs(query_params.get("created_date_to"), "YYYY-MM-DD")
      : parseDate(params?.created_date_to),
    dispatch_date_from: query_params.get("dispatch_date_from")
      ? dayjs(query_params.get("dispatch_date_from"), "YYYY-MM-DD")
      : parseDate(params?.dispatch_date_from),
    dispatch_date_to: query_params.get("dispatch_date_to")
      ? dayjs(query_params.get("dispatch_date_to"), "YYYY-MM-DD")
      : parseDate(params?.dispatch_date_to),
    sort_by: params?.sort_by ?? "dispatch_date",
    sort_type: params?.sort_type ?? SortType.DESC,
  };
}

export function getBaseFilters(): OpsSyncFilters {
  return {
    page_no: 1,
    limit: 30,
    sort_by: "dispatch_date",
    sort_type: SortType.DESC,
    dispatch_date_filter_type: null,
    order_id: [],
    order_type: defaultOrderTypes(),
    payment_status_id: [],
    order_category: [],
    created_date_from: null,
    created_date_to: null,
    dispatch_date_from: null,
    dispatch_date_to: null,
  };
}
